/* RESET product gallery navigation.
   Keeps Shopify media, bundle detail views, arrows, and accessible state in sync. */
(function () {
  function replayReveal(img) {
    if (!img || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    img.classList.remove('reset-media-anim');
    void img.offsetWidth;
    img.classList.add('reset-media-anim');
  }

  function initGallery(gallery) {
    if (gallery.dataset.resetNavReady) return;

    var viewer = gallery.querySelector('[id^="GalleryViewer"]');
    if (!viewer) return;

    var navButtons = Array.prototype.slice.call(
      viewer.querySelectorAll('[data-reset-gallery-nav]')
    );
    var slides = Array.prototype.filter.call(
      viewer.querySelectorAll('.product__media-item[data-media-id]'),
      function (slide) {
        if (slide.classList.contains('reset-gallery__default-hero')) return true;
        return !slide.classList.contains('product__media-item--variant');
      }
    );
    var rail = gallery.querySelector('.reset-bundle-media-thumbs');
    var railButtons = rail
      ? Array.prototype.slice.call(rail.querySelectorAll('.reset-bundle-media-thumbs__btn'))
      : [];

    if (slides.length < 2 && !railButtons.length) return;
    gallery.dataset.resetNavReady = 'true';

    navButtons.forEach(function (button) {
      button.removeAttribute('hidden');
    });

    var currentIndex = Math.max(
      0,
      railButtons.findIndex(function (button) {
        return button.getAttribute('aria-pressed') === 'true';
      })
    );
    var detailActive = false;
    var originalImages = new Map();

    function activeSlide() {
      return viewer.querySelector('.product__media-item.is-active') || slides[0] || null;
    }

    function activeImage() {
      var slide = activeSlide();
      return slide ? slide.querySelector('.media > img') : null;
    }

    function rememberImage(img) {
      if (!img || originalImages.has(img)) return;
      originalImages.set(img, {
        src: img.getAttribute('src') || img.src,
        srcset: img.getAttribute('srcset') || '',
        alt: img.getAttribute('alt') || ''
      });
    }

    function restoreImages() {
      originalImages.forEach(function (original, img) {
        img.setAttribute('src', original.src);
        img.setAttribute('srcset', original.srcset);
        img.setAttribute('alt', original.alt);
      });
      originalImages.clear();
    }

    function setZoomEnabled(enabled) {
      gallery.dataset.resetDetailActive = enabled ? 'false' : 'true';
      gallery.querySelectorAll('.product__media-toggle').forEach(function (button) {
        button.disabled = !enabled;
      });
    }

    function setRailActive(activeButton) {
      railButtons.forEach(function (button, index) {
        var selected = button === activeButton;
        button.classList.toggle('is-active', selected);
        button.setAttribute('aria-pressed', selected ? 'true' : 'false');
        if (selected) currentIndex = index;
      });
    }

    function updateStatus(message) {
      var status = gallery.querySelector('[id^="GalleryStatus"]');
      if (status) status.textContent = message || '';
    }

    function showMedia(button) {
      var mediaId = button.dataset.bundleMediaId;
      if (!mediaId) return;

      detailActive = false;
      restoreImages();
      setZoomEnabled(true);

      if (typeof gallery.setActiveMedia === 'function') {
        gallery.setActiveMedia(mediaId, false);
      } else {
        slides.forEach(function (slide) {
          slide.classList.toggle('is-active', slide.dataset.mediaId === mediaId);
        });
      }

      setRailActive(button);
      updateStatus(button.getAttribute('aria-label'));
      replayReveal(activeImage());
    }

    function showDetailSrc(src, alt) {
      var hostMedia = railButtons.find(function (item) {
        return item.dataset.bundleKind === 'media';
      });
      if (hostMedia && hostMedia.dataset.bundleMediaId && typeof gallery.setActiveMedia === 'function') {
        restoreImages();
        gallery.setActiveMedia(hostMedia.dataset.bundleMediaId, false);
      }

      var img = activeImage();
      if (!img) return null;

      rememberImage(img);
      img.src = src;
      img.srcset = '';
      if (alt) img.alt = alt;

      detailActive = true;
      setZoomEnabled(false);
      replayReveal(img);
      return img;
    }

    function showDetail(button) {
      if (!button.dataset.bundleSrc) return;
      var img = showDetailSrc(button.dataset.bundleSrc, button.dataset.bundleAlt || '');
      if (!img) return;
      setRailActive(button);
      updateStatus(button.getAttribute('aria-label'));
    }

    function activateRailButton(button) {
      if (!button) return;
      if (button.dataset.bundleKind === 'detail') {
        showDetail(button);
      } else {
        showMedia(button);
      }
    }

    function step(direction) {
      if (railButtons.length) {
        var next = (currentIndex + direction + railButtons.length) % railButtons.length;
        activateRailButton(railButtons[next]);
        return;
      }

      var activeIndex = slides.findIndex(function (slide) {
        return slide.classList.contains('is-active');
      });
      var nextIndex = (Math.max(activeIndex, 0) + direction + slides.length) % slides.length;
      var mediaId = slides[nextIndex].dataset.mediaId;
      if (typeof gallery.setActiveMedia === 'function') {
        gallery.setActiveMedia(mediaId, false);
      }
      replayReveal(activeImage());
    }

    navButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        step(button.dataset.resetGalleryNav === 'prev' ? -1 : 1);
      });
    });

    document.addEventListener('reset:bundle:paddle', function (event) {
      var detail = event.detail || {};
      if (!detail.src) return;
      var img = showDetailSrc(detail.src, detail.alt || '');
      if (!img) return;
      setRailActive(null);
      updateStatus(detail.alt ? 'Showing ' + detail.alt : '');
    });

    if (rail) {
      rail.addEventListener('click', function (event) {
        var button = event.target.closest('.reset-bundle-media-thumbs__btn');
        if (!button || !rail.contains(button)) return;
        activateRailButton(button);
      });

      rail.addEventListener('keydown', function (event) {
        var button = event.target.closest('.reset-bundle-media-thumbs__btn');
        if (!button) return;

        var index = railButtons.indexOf(button);
        var targetIndex = null;
        if (event.key === 'ArrowDown' || event.key === 'ArrowRight') targetIndex = index + 1;
        if (event.key === 'ArrowUp' || event.key === 'ArrowLeft') targetIndex = index - 1;
        if (event.key === 'Home') targetIndex = 0;
        if (event.key === 'End') targetIndex = railButtons.length - 1;
        if (targetIndex === null) return;

        event.preventDefault();
        targetIndex = (targetIndex + railButtons.length) % railButtons.length;
        railButtons[targetIndex].focus();
        activateRailButton(railButtons[targetIndex]);
      });

      railButtons.forEach(function (button) {
        if (button.dataset.bundleKind !== 'detail' || !button.dataset.bundleSrc) return;
        var preload = new Image();
        preload.src = button.dataset.bundleSrc;
      });

      var observer = new MutationObserver(function () {
        if (detailActive) return;
        var slide = activeSlide();
        if (!slide) return;
        var matchingButton = railButtons.find(function (button) {
          return button.dataset.bundleMediaId === slide.dataset.mediaId;
        });
        if (matchingButton) setRailActive(matchingButton);
      });
      slides.forEach(function (slide) {
        observer.observe(slide, { attributes: true, attributeFilter: ['class'] });
      });
    }
  }

  function initAll(root) {
    (root || document).querySelectorAll('media-gallery').forEach(initGallery);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
